/** DOCX typography + color tokens for the counsel/portfolio builder.
 *  House style (academic-editorial): Georgia is the Word-safe substitute the
 *  font registry maps BOTH house serifs to (Newsreader body + Fraunces display
 *  → Georgia), so the fixed-format counsel deliverable reads in the same serif
 *  voice as the template-aware in-app DOCX. No font embedding — Georgia ships
 *  with Word/Pages. */
export const DOCX_FONT = 'Georgia';
export const DOCX_FONT_FALLBACK = 'Times New Roman';

export const DOCX_SIZES = {
  coverTitle: 52,
  h1: 32,
  h2: 28,
  h3: 24,
  body: 22,
  small: 18,
  footnote: 18,
} as const;

export const DOCX_COLORS = {
  // House style — single TEAL accent (#0e6f7c) for headings / cover title /
  // callout labels / linked references (was the legacy brand blue 0071DF).
  brand: '0E6F7C',
  textPrimary: '1F2937',
  textMuted: '6B7280',
  textSecondary: '374151',
  confidential: '991B1B',
  border: 'E5E7EB',
  tableHeader: 'F3F4F6',
  /** L1 pillar cell tokens */
  pillarGreen: 'DCFCE7',
  pillarGreenText: '166534',
  pillarAmber: 'FEF3C7',
  pillarAmberText: '92400E',
  pillarRed: 'FEE2E2',
  pillarRedText: '991B1B',
  bandGreen: '059669',
  bandAmber: 'D97706',
  bandOrange: 'EA580C',
  bandRed: 'DC2626',
} as const;

export function pillarCellColors(level: 'green' | 'amber' | 'red'): { fill: string; text: string } {
  switch (level) {
    case 'green':
      return { fill: DOCX_COLORS.pillarGreen, text: DOCX_COLORS.pillarGreenText };
    case 'amber':
      return { fill: DOCX_COLORS.pillarAmber, text: DOCX_COLORS.pillarAmberText };
    case 'red':
      return { fill: DOCX_COLORS.pillarRed, text: DOCX_COLORS.pillarRedText };
  }
}

export function bandHex(color: 'green' | 'amber' | 'orange' | 'red'): string {
  switch (color) {
    case 'green': return DOCX_COLORS.bandGreen;
    case 'amber': return DOCX_COLORS.bandAmber;
    case 'orange': return DOCX_COLORS.bandOrange;
    case 'red': return DOCX_COLORS.bandRed;
  }
}
